import img1 from '../../assets/images/product/thunb-2.jpg';
import img2 from '../../assets/images/product/thunb-2.jpg';
import img3 from '../../assets/images/product/thunb-4.jpg';
import img4 from '../../assets/images/product/thunb-5.jpg';

export const ImageTableData = [
    {
        image: img1,
        inputvalue: 'Oculus VR back',
        colorvalue: '#cccccc',
        qvalue: '1',
    },
    {
        image: img2,
        inputvalue: 'Oculus VR right',
        colorvalue: '#426531',
        qvalue: '1',
    },
    {
        image: img3,
        inputvalue: 'Oculus VR left',
        colorvalue: '#547681',
        qvalue: '1',
    },
    {
        image: img4,
        inputvalue: 'Oculus VR Front',
        colorvalue: '#45df81',
        qvalue: '1',
    }


]